<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="tp">LEAVING THE<br/><br/>ENCHANTED FOREST</p>
<p class="tp1"><em>The Path from Relationship Addiction<br/>to Intimacy</em></p>
<p class="au"><em>Stephanie Covington<br/><br/>and<br/><br/>Liana Beckett</em><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780062043740_L01.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062043740_epub_tp_r1.vue?6c158cc8